<template>
  <div class="export-funds-report">
    <contextual-menu
      v-if="!error"
      class="export-funds-report-menu__fund-reports"
      position="bottom-left"
      text="Settings"
      :options="options"
      size="300px"
      @selected="optionSelected"
    >
      <template slot="clickTrigger">
        <mds-button variation="flat" icon="download"> Download </mds-button>
      </template>
    </contextual-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { debounce, get } from 'lodash';
import { getFundsReportList } from '@/services/FundsReports';
import ErrorNotificationMixin from '@/mixins/ErrorNotificationMixin';
import ContextualMenu from '@/components/molecules/ContextualMenu';

export default {
  name: 'ExportFundsReportMenu',
  components: {
    ContextualMenu,
  },
  mixins: [
    ErrorNotificationMixin({ component: 'SubmitChanges' }),
  ],
  data() {
    return {
      isLoading: true,
      error: false,
      requestController: null,
      request: null,
      requestUrl: '',
      debouncing: {},
      options: [
        {
          id: 'loading',
          text: 'Loading...',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      selectedFiduciary: (state) => state.user.fiduciary,
    }),
  },
  methods: {
    ...mapActions([
      'logError',
    ]),
    optionSelected(selectedOption) {
      const link = get(selectedOption, 'data.link');
      if (link) {
        window.open(link);
      }
    },
    loadReports() {
      if (this.isLoading && this.request && this.requestController) {
        this.requestController.abort();
        this.request = null;
      }
      this.isLoading = true;
      getFundsReportList({
        selectedFiduciary: this.selectedFiduciary,
      }).then((result) => {
        const { reports = [] } = result.data ? result.data : result;
        this.options = reports.map((report) => {
          return {
            id: `fund-report-${report.id}`,
            text: report.displayName,
            data: {
              link: report.url,
              ...report,
            },
          };
        });
        this.isLoading = false;
      }).catch((error) => {
        this.error = true;
        this.logError({
          data: {
            selectedFiduciary: this.selectedFiduciary,
          },
          errorFrom: 'ExportFundsReport:methods:loadReports',
          details: {
            ...Object.getOwnPropertyDescriptors(error),
            message: error.message,
          },
        });
        if (error.name !== 'AbortError') {
          this.notifyError({
            error,
            section: 'lifecycle:created',
            data: { url: this.requestUrl },
            notificaction: {
              title: 'Export Funds Report',
              message: `Fetching list of reports (Error: ${error.message})`,
            },
          });
        }
        this.isLoading = false;
      });
    },
  },
  created() {
    this.error = false;
    this.loadReports();

    // It should be called every hour, because the provided link expires after that time
    this.debouncing = debounce(async () => {
      return this.loadReports();
    }, 3600 * 1000);
  },
  beforeDestroy() {
    this.requestController && this.requestController.abort();
    this.isLoading = false;
  },
};
</script>
